"use strict";

var cmxSDK = require('@nackle/cmx-sdk');

var _require = require('../utils/endpoints'),
    cmxUrl = _require.cmxUrl;

var _require2 = require('../utils/error'),
    throwServiceError = _require2.throwServiceError;

var SERVICE_NAME = 'cmx';

module.exports = function (_ref) {
  var fetch = _ref.fetch;
  var sdk = new cmxSDK(cmxUrl, fetch);

  var getBundle = function getBundle(project, locale, keys) {
    return new Promise(function ($return, $error) {
      var response;

      var $Try_1_Post = function () {
        try {
          return $return();
        } catch ($boundEx) {
          return $error($boundEx);
        }
      };

      var $Try_1_Catch = function (error) {
        try {
          throwServiceError(SERVICE_NAME, error, 'getBundle');
          return $Try_1_Post();
        } catch ($boundEx) {
          return $error($boundEx);
        }
      };

      try {
        return Promise.resolve(sdk.getBundle(project, locale, keys)).then(function ($await_4) {
          try {
            response = $await_4;

            // if a single locale was passed in, return that specific bundle
            if (typeof locale === 'string') {
              return $return(response.bundles[locale]);
            }

            return $return(response);
          } catch ($boundEx) {
            return $Try_1_Catch($boundEx);
          }
        }, $Try_1_Catch);
      } catch (error) {
        $Try_1_Catch(error)
      }
    });
  }; // specific keys are not supported


  var getBundles = function getBundles(projects, locale) {
    return new Promise(function ($return, $error) {
      var response, i, project, bundle;
      response = {};
      i = 0;
      var $Loop_2_trampoline;

      function $Loop_2_step() {
        i++;
        return $Loop_2;
      }

      function $Loop_2() {
        if (i < projects.length) {
          project = projects[i];
          return Promise.resolve(getBundle(project, locale)).then(function ($await_5) {
            try {
              bundle = $await_5;
              response[project] = bundle;
              return $Loop_2_step;
            } catch ($boundEx) {
              return $error($boundEx);
            }
          }, $error);
        } else return [1];
      }

      return ($Loop_2_trampoline = function (q) {
        while (q) {
          if (q.then) return void q.then($Loop_2_trampoline, $error);

          try {
            if (q.pop) {
              if (q.length) return q.pop() ? $Loop_2_exit.call(this) : q;else q = $Loop_2_step;
            } else q = q.call(this);
          } catch (_exception) {
            return $error(_exception);
          }
        }
      }.bind(this))($Loop_2);

      function $Loop_2_exit() {
        return $return(response);
      }
    });
  };

  return {
    getBundle: getBundle,
    getBundles: getBundles
  };
};
//# sourceMappingURL=cmx.js.map